import { SortDirType } from "../../../common/SortDirType";
import { SortParams } from "../../../common/SortParams";

export const sortByFields = [
  { label: "Company Name", value: "COMPANY_NAME" },
  { label: "Location Name", value: "LOCATION_NAME" },
  { label: "Phone Number", value: "PHONE_NUMBER" },
  { label: "Company Email", value: "COMPANY_EMAIL" },
  { label: "City", value: "CITY" },
  { label: "State", value: "STATE" },
  { label: "Instant Approval", value: "INSTANT_APPROVAL" },
  { label: "Allows Daily Bookings", value: "ALLOWS_DAILY_BOOKINGS" },
  { label: "Subscription Type", value: "SUBSCRIPTION_TYPE" },
] as const satisfies Array<{label: string, value: string}>;

export type AdminLocationSortByType = typeof sortByFields[number]['value'];

export interface AdminLocationSortParams extends SortParams {
  sortBy?: AdminLocationSortByType;
  sortDir?: SortDirType
}